const React = require('react');
const Loading = require('../Loading');
const Button = require('react-bootstrap').Button;
const Table = require('react-bootstrap').Table;
const Invocation = require('../../api/Invocation');
const ServiceDebuggerVisionData = require('./ServiceDebuggerVisionData');
const moment = require('moment');

var ServiceDebugger = React.createClass({
  loadDiagnostics: function () {
    this.setState({
      loading: true,
      loadingVision: true
    });

    Invocation.clientService.diagnostics(this.props.id)
      .then((res) => {
        this.setState({
          data: res.body,
          loading: false,
        })
      });

    Invocation.clientService.getVisionServiceDetails(this.props.id)
      .then((res) => {
        this.setState({
          visionData: res.body.details ? res.body.details : null,
          loadingVision: false
        })
      }).catch((e) => {
        if (e.res.status == 404) {
          this.setState({
            visionError: e.res.body.error,
            loadingVision: false
          });
        } else if (e.res.status == 400) {
          console.log(e.res.body.error);
          this.setState({
            loadingVision: false
          });
        } else {
          this.setState({
            visionError: e.err.message,
            loadingVision: false
          });
        }
      });
  },

  getInitialState: function () {
    return {
      data: null,
      loading: false,
      loadingVision: false,
      visionData: null,
      visionError: null
    };
  },

  render: function () {
    if (this.state.loading || this.state.loadingVision) {
      return <Loading />;
    }

    if (!this.state.data) {
      return (
        <Button onClick={this.loadDiagnostics}>Load Diagnostics</Button>
      )
    }

    if (false === this.state.data.hasDiagnosticData && (this.state.visionData == null)) {
      return (

        <div>
          <p>
            There is no diagnostic information available for this service at this
            time. For help with diagnostics on this service please contact Support.
          </p>
        </div>
      )
    }

    const hasDiagnostics =
      this.state.data.connected !== undefined ||
      this.state.data.average_session_length !== undefined ||
      this.state.data.potential_problems.length ||
      this.state.data.recent_connections.length > 0 || 
      this.state.visionData != null

    if (!hasDiagnostics) {
      return <p>No diagnostic information is currently available for this service.</p>
    }

    return (
      <div>
        {this.state.visionData != null && (
          <ServiceDebuggerVisionData data={this.state.visionData} />
        )}

        {this.state.visionError != null && (
          <div>
            <h4>Vision details</h4>
            <Table className="table-striped table-hover">
              <tbody>
                <tr>
                  <th>
                    Error
                  </th>
                  <td>
                    {this.state.visionError}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        )}

        <Table className="table-striped table-hover">
          <tbody>
            {this.state.data.connected !== undefined && (
              <tr>
                <th>Connected</th>
                <td>{this.state.data.connected ? 'Connected' : 'Not Connected'}</td>
              </tr>
            )}
            {this.state.data.average_session_length !== undefined && (
              <tr>
                <th>
                  <span className="help" title="A low average session length may indicate a problem with the router at your premises."><i className="fa fa-question-circle"></i></span>
                  Average Session Length
                </th>
                <td>{moment.duration(this.state.data.average_session_length, 'seconds').asDays().toFixed(1)} days</td>
              </tr>
            )}
            {this.state.data.potential_problems.length > 0 && (
              <tr>
                <th>
                  Detected Problems
                </th>
                <td>
                  {this.state.data.potential_problems.join(', ')}
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {this.state.data.recent_connections.length > 0 && (
          <Table className="table-striped table-hover">
            <thead>
              <tr>
                <th style={{ whiteSpace: 'nowrap' }}>Start</th>
                <th style={{ whiteSpace: 'nowrap' }}>End</th>
                <th>Length</th>
                <th>Disconnection Reason</th>
              </tr>
            </thead>
            <tbody>
              {this.state.data.recent_connections.map(c => {
                const start = moment(c.start)
                const stop = c.stop ? moment(c.stop) : null
                const diff = stop ? moment.duration(stop.diff(start)) : null;

                return (
                  <tr key={c.start}>
                    <td style={{ whiteSpace: 'nowrap' }}>{start.format('YYYY-MM-DD HH:mm:ss')}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{stop ? stop.format('YYYY-MM-DD HH:mm:ss') : <em>Still Active</em>}</td>
                    <td>{diff && <span>{diff.asDays().toFixed(1)} days</span>}</td>
                    <td>{stop ? c.stop_reason : ''}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        )}
      </div>
    )
  }
})
module.exports = ServiceDebugger;



// WEBPACK FOOTER //
// ./app/components/ServiceDebugger/ServiceDebugger.js